module.exports = __webpack_public_path__ + "fc32069a4a7dcd68cd84b2a675d8c3eb.png";